/**
 * AuthLoginRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { StaffData } from './staff_data'

/**
 * AuthLoginRes
 */
export interface AuthLoginRes {
  /** 访问令牌 */
  access_token?: string
  /** 刷新令牌 */
  refresh_token?: string
  /** 访问令牌过期时间 */
  expire_at?: string
  /** 令牌类型 */
  token_type?: string
  /** 管理员信息 */
  staff?: StaffData
}

/**
 * AuthLoginRes Schema
 */
export const AuthLoginResSchema: SchemaDefinition = {
  properties: {
    access_token: {
      description: '访问令牌',
      format: 'string',
      type: 'string',
      label: '访问令牌',
    },
    refresh_token: {
      description: '刷新令牌',
      format: 'string',
      type: 'string',
      label: '刷新令牌',
    },
    expire_at: {
      description: '访问令牌过期时间',
      format: '*time.Time',
      type: 'string',
      label: '访问令牌过期时间',
    },
    token_type: {
      description: '令牌类型',
      format: 'string',
      type: 'string',
      label: '令牌类型',
    },
    staff: {
      $ref: 'StaffData',
      description: '管理员信息',
      label: '管理员信息',
    },
  },
  type: 'object',
}
